<section>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="user-dashboard-info-box">
          <button class="btn btn-sm btn-outline-secondary col-sm-12 mb-1 text-left" type="button"
          *ngFor="let notification of userNotifications"
          (click)="onNotificationClick(notification)">
          {{ notification.notificationText }}
          <span class="un-read-dot" *ngIf="!notification.isRead"></span>
          <span class="float-right">{{ notification.notificationDate | humanizeDate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
